<div class="p-2">
  <!-- Title -->
  <div class="row">
    <div class="col-12 h5 text-muted p-0">Change Password</div>
  </div>

  <div class="row bg-light p-2">
    <div class="col-12">

      <div class="row pt-2 pb-2 bg-white">
        <div class="col-12">

          <form [formGroup]="passwordForm" (ngSubmit)="onChangePassword()">

            <!-- Current Password -->
            <div class="row mt-4">
              <div class="col-md-6">
                <span class="text-muted fw-bold">
                  Current Password
                  <i-bs
                    name="infoCircle"
                    class="text-primary"
                    tooltip="Add your existing password."
                    placement="top">
                  </i-bs>
                </span>

                <input type="password" class="form-control mt-2" minlength="4" maxlength="20" formControlName="current_password" id="current_password" placeholder="">

                <span class="text-danger error-message" *ngIf="(passwordForm.controls.current_password.dirty || passwordForm.controls.current_password.touched) && passwordForm.controls.current_password.invalid">
                  Enter current password
                </span>
              </div>
            </div>

            <!-- New Password -->
            <div class="row mt-4">
              <div class="col-md-6">
                <span class="text-muted fw-bold">
                  New Password
                  <i-bs
                    name="infoCircle"
                    class="text-primary"
                    tooltip="Add your new password. Minimum length is 4 and maximum length is 20."
                    placement="top">
                  </i-bs>
                </span>

                <input type="password" class="form-control mt-2" minlength="4" maxlength="20" formControlName="new_password1" id="new_password1" placeholder="">

                <span class="text-danger error-message" *ngIf="(passwordForm.controls.new_password1.dirty || passwordForm.controls.new_password1.touched) && passwordForm.controls.new_password1.invalid">
                  Minimum length is 4 and maximum length is 20.
                </span>
              </div>
            </div>

            <!-- Confirm New Password -->
            <div class="row mt-4">
              <div class="col-md-6">
                <span class="text-muted fw-bold">
                  Confirm New Password
                  <i-bs
                    name="infoCircle"
                    class="text-primary"
                    tooltip="Add your new password again."
                    placement="top">
                  </i-bs>
                </span>

                <input type="password" class="form-control mt-2" minlength="4" maxlength="20" formControlName="new_password2" id="new_password2" placeholder="">

                <span class="text-danger error-message" *ngIf="(passwordForm.controls.new_password2.dirty || passwordForm.controls.new_password2.touched) && passwordForm.controls.new_password2.invalid">
                  New password is not matching.
                </span>
              </div>
            </div>

            <hr class="text-black-50 mt-4">

            <!-- Submit button -->
            <div class="row mt-3 mb-3">
              <div class="col-6">
              </div>
              <div class="col-6 text-end">
                <button type="submit" class="btn btn-secondary text-white" title="Change Password">
                  Change Password
                  <div class="spinner-border spinner-border-sm" role="status" *ngIf="buttonLoader"></div>
                </button>
              </div>
            </div>

          </form>

        </div>
      </div>

    </div>
  </div>
</div>
